import { contractProxy } from '@/api/index';

function getContract(params) {
  return contractProxy.get('', { params });
}

export { getContract };
